import { call, put, select, StrictEffect, takeEvery } from "redux-saga/effects";

import { AppError, extractError } from "@/jenesys-types/errors";

import { selectCompanyMembers } from "@/store/features/companyMembers/companyMembers";
import { parseCommentText } from "@/utils/commentParsing";

import {
  parseComment,
  parseCommentFailure,
  parseCommentSuccess
} from "./commentParsing";

function* parseCommentSaga(
  action: ReturnType<typeof parseComment>
): Generator<StrictEffect, void, any> {
  const { commentId, rawText } = action.payload;

  try {
    const companyMembers = yield select(selectCompanyMembers);
    const parsedComment = yield call(parseCommentText, rawText, companyMembers);

    yield put(parseCommentSuccess(commentId, parsedComment));
  } catch (error) {
    const appError: AppError = extractError(error);
    yield put(parseCommentFailure(appError));
  }
}

export default function* CommentParsingSaga() {
  yield takeEvery(parseComment.type, parseCommentSaga);
}
